import React from 'react';
import { Modal } from '@makemydeal/dr-activities-common';

export interface ITradeInRemovalConfirmationModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const TradeInRemovalConfirmationModal: React.FC<ITradeInRemovalConfirmationModalProps> = ({ show, onCancel, onConfirm }) => (
  <Modal
    show={show}
    elementToAttachModalTo=".checkout-wizard-layout__wrapper"
    elementToBlur=".checkout-wizard-layout__container"
    cls="dr-trade-in-removal-confirmation-modal"
    ariaLabel="Taking this action will delete your current estimated trade-in"
  >
    <div className="dr-trade-in-removal-confirmation-content">
      <h2 className="dr-trade-in-removal-confirmation-title">
        Taking this action will delete your current estimated trade-in
      </h2>
      <p className="dr-trade-in-removal-confirmation-body">
        Leaving this page without finishing your trade-in details will remove your estimated trade-in. Please note: if
        you choose to delete, you can immediately add a new trade-in.
      </p>
      <div className="dr-trade-in-removal-confirmation-actions">
        <button className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={onConfirm}>
          Delete This Trade-in
        </button>
      </div>
    </div>
  </Modal>
);

export default TradeInRemovalConfirmationModal;
